import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Select } from '@reveni-io/reveni-ui'

import { providers } from '@/returns/constants'

import { groupByOptions, nonShopifyExcludedValues } from './constants'

const ChartGroupBySelect = ({ onChange, value, provider }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getOptions = () => {
    const options = groupByOptions.map(o => ({ ...o, label: t(o.label) }))

    if (provider !== providers.shopify) {
      return options.filter(o => !nonShopifyExcludedValues.includes(o.value))
    }

    return options
  }

  return (
    <Select
      backgroundColor={theme.colors.background.secondary}
      onChange={onChange}
      value={value}
      options={getOptions()}
    />
  )
}

export default ChartGroupBySelect
